module.exports = __webpack_public_path__ + "202408221624/img/icon_product_1.109948a3.png";